/**
 * <hy-responsive-details>: disclosures that are open on wide screens and
 * collapsed on phones (product page design of 24.09.2026: document groups
 * "Datenblatt (3)", "Alle 7 Fragen anzeigen").
 *
 * The markup renders every <details> with `open`, so without this module all
 * content is visible — nothing hides behind a control that cannot open. The
 * module only adds the phone behaviour: below 48rem it closes the direct
 * <details> it wraps (once on connect and whenever the width crosses the
 * breakpoint); from 48rem on it keeps them open and ignores clicks on their
 * summary, which serves as a plain title there.
 */
const NARROW = '(max-width: 47.99rem)';

class HyResponsiveDetails extends HTMLElement {
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    const query = window.matchMedia(NARROW);

    const sync = () => {
      this.#items().forEach((item) => {
        item.open = !query.matches;
        // No tab stop on wide screens, where the summary cannot toggle.
        const summary = item.querySelector(':scope > summary');
        if (summary) summary.tabIndex = query.matches ? 0 : -1;
      });
    };

    sync();
    query.addEventListener('change', sync, { signal });

    // Wide screens: the summary is a title, not a toggle.
    this.addEventListener(
      'click',
      (event) => {
        if (query.matches) return;
        const summary = event.target.closest('summary');
        if (summary && this.#items().includes(summary.parentElement)) event.preventDefault();
      },
      { signal },
    );

    this.setAttribute('data-hy-details-ready', '');
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = null;
  }

  #items() {
    return [...this.querySelectorAll('details[data-hy-responsive]')];
  }
}

customElements.define('hy-responsive-details', HyResponsiveDetails);
